<template>
  <div class="document-data-wrapper">
    <div class="document-data-l">
      <span class="document-data-l-label">{{data.text}}</span>
      <span class="document-data-l-value">{{dataFormatterThousands(data.value)}}</span>
    </div>
    <ul class="document-data-r">
      <li
        v-for="(item, index) in data.list"
        :key="index"
      >
        <p class="document-data-r-label">{{item.name}}</p>
        <p class="document-data-r-value">{{dataFormatterThousands(item.value)}}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  name: 'documentData',
  data() {
    return {
      anima: '',
      data: {
        text: '凭证数据',
        value: 0,
        list: [
          { name: '药品批次', value: 0 },
          { name: '票证数量', value: 0 },
          { name: '终端数量', value: 0 },
          { name: '消费者数量', value: 0 }
        ]
      },
      documentsNum: 163210012,
      drugBatch: 15695091,
      ticketNum: 233500373,
      terminals: 7603521,
      consumerNum: 57002371
    }
  },
  mounted() {
    let me = this
    vueBus.$on('imgOnload', v => {
      me.anima = v
    })
  },
  watch: {
    anima(val, oldVal) {
      val == 'animateStart' && this.animate()
    }
  },
  methods: {
    animate() {
      let me = this
      this.TweenMax.to(this.data, 3, { value: 163210012 })
      this.TweenMax.to(this.data.list[0], 3, { value: 15695091 })
      this.TweenMax.to(this.data.list[1], 3, { value: 233500373 })
      this.TweenMax.to(this.data.list[2], 3, { value: 7603521 })
      this.TweenMax.to(this.data.list[3], 3, { value: 57002371 })
      var start = +new Date()
      var val1 = 0
      var val2 = 0
      var val3 = 0
      var val4 = 0
      var val5 = 0
      setInterval(function() {
        var end = +new Date()
        if (end - start >= 36000000) {
          start = end
          me.TweenMax.to(me.data, 1, { value: 163210012 })
          me.TweenMax.to(me.data.list[0], 1, { value: 15695091 })
          me.TweenMax.to(me.data.list[1], 1, { value: 233500373 })
          me.TweenMax.to(me.data.list[2], 1, { value: 7603521 })
          me.TweenMax.to(me.data.list[3], 1, { value: 57002371 })
          me.data.value = 163210012
          me.data.list[0].value = 15695091
          me.data.list[1].value = 233500373
          me.data.list[2].value = 7603521
          me.data.list[3].value = 57002371
        } else {
          val1 = Math.floor(Math.random() * 20) + 33
          val2 = Math.floor(Math.random() * 20) + 33
          val3 = Math.floor(Math.random() * 20) + 33
          val4 = Math.floor(Math.random() * 20) + 33
          val5 = Math.floor(Math.random() * 20) + 33
          me.TweenMax.to(me.data, 2, { value: me.data.value + val1 })
          me.TweenMax.to(me.data.list[0], 1.5, { value: me.data.list[0].value + val2 })
          me.TweenMax.to(me.data.list[1], 1.8, { value: me.data.list[1].value + val3 })
          me.TweenMax.to(me.data.list[2], 2.2, { value: me.data.list[2].value + val4 })
          me.TweenMax.to(me.data.list[3], 2.3, { value: me.data.list[3].value + val5 })
        }
      }, 4000)
    },
    dataFormatterThousands(s) {
      /*
       * 参数说明：
       * s：要格式化的数字
       * */
      s = parseFloat((s + '').replace(/[^\d\.-]/g, '')) + ''
      var l = s
        .split('.')[0]
        .split('')
        .reverse()
      var t = ''
      for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '')
      }
      return t
        .split('')
        .reverse()
        .join('')
    }
  }
}
</script>
<style lang="scss" scoped>
.document-data-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  color: #66ebc2;
  .document-data-l {
    float: left;
    line-height: 228px;
    font-weight: 700;
    .document-data-l-label {
      font-size: 63px;
      margin-right: 96px;
    }
    .document-data-l-value {
      font-size: 100px;
    }
  }
  .document-data-r {
    
    float: right;
    margin-right: 40px;
    padding: 65px 0;
    li {
      position: relative;
      float: left;
      width: 296px;
      text-align: center;
      font-weight: 700;
      z-index: 10000;
      .document-data-r-label {
        font-size: 38px;
        font-weight: normal;
      }
      .document-data-r-value {
        font-size: 36px;
        font-weight: normal;
      }
      &::after{
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 5px;
        height: 100%;
        background: linear-gradient(rgba(123,168,150, 0), rgba(123,168,150, 1), rgba(123,168,150, 0)); /* 标准的语法 */
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/documentData/index.vue